"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverCard = void 0;
var Utilities_1 = require("../../Utilities");
var HoverCard_styles_1 = require("./HoverCard.styles");
var HoverCard_base_1 = require("./HoverCard.base");
exports.HoverCard = (0, Utilities_1.styled)(HoverCard_base_1.HoverCardBase, HoverCard_styles_1.getStyles, undefined, {
    scope: 'HoverCard',
});
//# sourceMappingURL=HoverCard.js.map